import { importTypes, settingStepFields } from '../config/import';
import { getSettingStepRequiredFieldSize, stateKeys } from './config';
import { uploadingFieldNames } from '../config/uploadingStep';

export const getPageState = (state) => state.housingStockStore.importsPageState;

export const selectCompanyId = (state) =>
  state.housingStockStore.currentCompany?.id;

export const selectStateValue = (state, key) => getPageState(state)[key];

export const selectUploadingStepValue = (state, name) =>
  selectStateValue(state, stateKeys.uploadingValues).get(name);

export const selectUploadingStepError = (state, name) =>
  selectStateValue(state, stateKeys.uploadingErrors).get(name);

export const selectCanGoToSettingStep = (state) => {
  const {
    [stateKeys.uploadingValues]: values,
    [stateKeys.uploadingErrors]: errors,
  } = getPageState(state);

  const importType = values.get(uploadingFieldNames.importType);
  const scopeField =
    importType === importTypes.personalAccountsByCompanies
      ? uploadingFieldNames.accountType
      : uploadingFieldNames.house;
  const requiredFields = [
    uploadingFieldNames.importType,
    scopeField,
    uploadingFieldNames.file,
    uploadingFieldNames.sheet,
    ...(importType === importTypes.personalAccountsByCompanies
      ? [uploadingFieldNames.dataStartRow]
      : []),
  ];

  return requiredFields.every(
    (field) => values.has(field) && !errors.has(field)
  );
};

export const selectSettingStepValue = (state, name) =>
  selectStateValue(state, stateKeys.settingValues).get(name);

export const selectSettingStepError = (state, name) =>
  selectStateValue(state, stateKeys.settingErrors).get(name);

export const selectCanGoToPreviewStep = (state) => {
  const {
    [stateKeys.settingValues]: values,
    [stateKeys.settingErrors]: errors,
    [stateKeys.uploadingValues]: uploadingValues,
  } = getPageState(state);

  const importType = uploadingValues.get(uploadingFieldNames.importType);
  const fieldSize = getSettingStepRequiredFieldSize(
    settingStepFields[importType]
  );

  return errors.size === 0 && values.size >= fieldSize;
};

export const selectIsNavigationBlocked = (state) => {
  const pageState = getPageState(state);

  const uploadingValues = pageState[stateKeys.uploadingValues];
  const settingValues = pageState[stateKeys.settingValues];

  return uploadingValues.size > 0 || settingValues.size > 0;
};
